import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import { createTheme, ThemeProvider, StyledEngineProvider, CssBaseline } from "@mui/material";
import moment from "moment";
import { APIProvider, AlertProvider, useAlert } from "react-common";
import { useTranslation } from "react-i18next";
import { apiConfig } from "./utils/apiConfig";
import App from "./components/App";
import "./utils/i18n";
import "./styles/icons.css";
import ErrorBoundaryWrapper from "./ErrorBoundary";

const theme = createTheme({
    palette: {
        primary: {
            main: "rgba(54, 142, 196, 1)"
        },
        default: {
            main: "#e0e0e0",
            contrastText: "black",
            dark: "#d5d5d5"
        }
    },
    components: {
        // Style sheet name ⚛️
        MuiButton: {
            defaultProps: {
                color: "default"
            },
            styleOverrides: {
                // Name of the rule
                root: {
                    textTransform: "none"
                }
            },
            variants: [
                {
                    props: { color: "default", variant: "outlined" },
                    style: {
                        border: "1px solid rgba(0, 0, 0, 0.23)",
                        color: "black"
                    }
                }
            ]
        }
    }
});

const APIWrapper = () => {
    const alert = useAlert();
    const { t, i18n } = useTranslation();
    const location = useLocation();
    useEffect(() => {
        moment.locale(i18n.language);
    }, [i18n.language]);

    const iam = new URLSearchParams(location.search).get("iam");
    return (
        <APIProvider
            {...apiConfig}
            defaultOptions={{
                headers: {
                    "Content-Type": "application/json",
                    "X-Impersonate": iam || ""
                }
            }}
            onError={(e) => {
                if (e.error && e.error.message) {
                    if(e.error.code === 404 || e.error.code === 403){
                        console.log(e.error)
                    } else {
                        alert.error(t(["errorMessage." + e.error.message, "errorMessage.unknownError"]));
                    }
                }
            }}
        >
            <App />
        </APIProvider>
    );
};

document.getElementById("splashscreen").remove();
createRoot(document.getElementById("app")).render(
    <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <ErrorBoundaryWrapper>
                <Router>
                    <AlertProvider>
                        <APIWrapper />
                    </AlertProvider>
                </Router>
            </ErrorBoundaryWrapper>
        </ThemeProvider>
    </StyledEngineProvider>
);
